import { FAMILY_ORDER_COPY } from '../constants/messages';

const latestLessonByFamily = (students) => {
  const latestByFamily = new Map();
  for (const student of students) {
    if (!student.last_lesson_date) continue;
    const previous = latestByFamily.get(student.family_id);
    if (!previous || student.last_lesson_date > previous) {
      latestByFamily.set(student.family_id, student.last_lesson_date);
    }
  }
  return latestByFamily;
};

/** Families sorted by their students' latest lesson (newest first), then by name. */
export const orderFamiliesByRecentLesson = (families, students) => {
  const latestByFamily = latestLessonByFamily(students);
  return [...families].sort((a, b) => {
    const aDate = latestByFamily.get(a.family_id) || '';
    const bDate = latestByFamily.get(b.family_id) || '';
    return bDate.localeCompare(aDate)
      || `${a.last_name} ${a.first_name}`.localeCompare(`${b.last_name} ${b.first_name}`, 'fr');
  });
};

/** The `count` families with the most recent lessons; families without any lesson are left out. */
export const familiesOfRecentLessons = (families, students, count) => {
  const latestByFamily = latestLessonByFamily(students);
  return orderFamiliesByRecentLesson(families, students)
    .filter((family) => latestByFamily.has(family.family_id))
    .slice(0, count);
};

export const familySelectOptions = (families, students) => {
  const namesByFamily = new Map();
  for (const student of students) {
    const names = namesByFamily.get(student.family_id) || [];
    names.push(`${student.first_name} ${student.last_name}`);
    namesByFamily.set(student.family_id, names);
  }
  const [lastLessonFamily] = familiesOfRecentLessons(families, students, 1);
  return orderFamiliesByRecentLesson(families, students).map((family) => ({
    value: family.family_id,
    label: `${family.first_name} ${family.last_name}`,
    hint: family === lastLessonFamily ? FAMILY_ORDER_COPY.lastLesson : undefined,
    searchableText: `${family.first_name} ${family.last_name} ${family.family_code || ''} ${(namesByFamily.get(family.family_id) || []).join(' ')}`,
  }));
};
